import { useParams } from 'react-router-dom'

import { useGetCaseQuery } from '@acre/graphql'

import type { UseRouteDataHookProps } from './types'

const useRouteForCase = (
  { fetchPolicy = 'cache-first', skip = false, warn = true }: UseRouteDataHookProps = {
    fetchPolicy: 'cache-first',
    skip: false,
    warn: true,
  },
) => {
  const { caseId } = useParams<{ caseId?: string }>()

  const { data, loading, error } = useGetCaseQuery({
    variables: { id: caseId! },
    fetchPolicy,
    skip: skip || !caseId,
  })

  if (warn && !caseId && !skip) {
    console.warn('useRouteForCase: caseId was not found in route. This is possibly a bug.')
  }

  return { data: data?.case, loading, error }
}

export default useRouteForCase
